import { render, staticRenderFns } from "./PagePagination.vue?vue&type=template&id=f53979ce&scoped=true"
import script from "./PagePagination.vue?vue&type=script&lang=js"
export * from "./PagePagination.vue?vue&type=script&lang=js"
import style0 from "./PagePagination.vue?vue&type=style&index=0&id=f53979ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53979ce",
  null
  
)

export default component.exports